import { PredictionLabel } from '@modules/common/components/PredictionLabel';
import { getFeedbackLabelIcon } from '@modules/feedback/components/FeedbackCard/utils/getFeedbackLabelIcon';
import { useIsFeedbackOnFeedbackEnabled } from '@modules/feedback/hooks';
import { useIsFeedbackRedesignEnabled } from '@modules/feedbackV2/common/hooks';
import { Stack } from '@mui/material';
import { ReasonOrEntityLabelType } from 'v2/core/entities/feedback/labels';
import { CategoryIcon } from '../CategoryIcon';
import { LabelChip } from './LabelChip';

interface LabelChipWithCategoryIconProps {
  label: ReasonOrEntityLabelType;
}

export const LabelChipWithCategoryIcon = ({
  label,
}: LabelChipWithCategoryIconProps) => {
  const { isFeedbackOnFeedbackEnabled } = useIsFeedbackOnFeedbackEnabled();

  const isFeedbackRedesignEnabled = useIsFeedbackRedesignEnabled();

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {label.type === 'REASON' ? (
        <CategoryIcon category={label.category ?? null} size={14} /> //TODO: remove fallback after contract update
      ) : (
        <Stack direction="row">
          {label.entityUnits?.map((entity) => (
            <CategoryIcon
              category={entity.category ?? null}
              size={14}
              key={entity.category}
            /> //TODO: remove fallback after contract update
          ))}
        </Stack>
      )}
      {isFeedbackOnFeedbackEnabled ? (
        <PredictionLabel label={label} />
      ) : (
        <LabelChip
          displayName={label.displayName}
          renderLabelIcon={() =>
            getFeedbackLabelIcon({
              label,
              shouldShowPrimaryColor: !isFeedbackRedesignEnabled,
            })
          }
        />
      )}
    </Stack>
  );
};
